/* @flow */

import * as React from 'react';

import {LockedIcon} from '../icon';
import {colors} from '../colors';

import './lock-avatar.css';

export const DEFAULT_SIZE = 30;

type Props = {
    size: number,
    backgroundColor?: string,
};

export function LockAvatar(props: Props) {
    const style = {
        width: `${props.size}px`,
        height: `${props.size}px`,
        lineHeight: `${props.size}px`,
        borderRadius: `${props.size}px`,
        backgroundColor: props.backgroundColor,
    };

    return (
        <div styleName='container' style={style}>
            <LockedIcon size={Math.floor(props.size / 2)} fill={colors.white} />
        </div>
    );
}
